@if (isDisabled) {
  <nb-form-field>
    <input nbInput
           type="text"
           placeholder="TGA Bauplan suchen"
           [ngModel]="getEquipmentTitle(value)"
           fullWidth
           [disabled]="true" />
    @if (value) {
      <button nbSuffix
              nbButton
              ghost
              (click)="goToEquipment()"
              nbTooltip="Zum TGA Bauplan">
        <nb-icon icon="external-link-outline"
                 pack="eva">
        </nb-icon>
      </button>
    }
  </nb-form-field>
} @else {
  <nb-form-field>
    <input nbInput
           type="text"
           #searchInput
           [ngModel]="getEquipmentTitle(value)"
           (ngModelChange)="filterText$.next($event)"
           placeholder="TGA Bauplan suchen"
           [nbPopover]="popoverTemplate"
           [nbPopoverPlacement]="'bottom-end'"
           [nbPopoverTrigger]="'focus'"
           (keydown.enter)="$event.preventDefault()"
           fullWidth/>
    @if (value) {
      <button nbSuffix nbButton ghost (click)="clear()">
        <nb-icon icon="close-outline"
                 pack="eva">
        </nb-icon>
      </button>
    }
  </nb-form-field>

  <ng-template #popoverTemplate>
    <div class="autocomplete-dropdown">
      <nb-list nbInfiniteList (bottomThreshold)="loadMore$.next()" [threshold]="50" [throttleTime]="100">
        @for (equipment of (equipments$ | async) ?? []; track equipment.id) {
          <nb-list-item (click)="onSelectionChange(equipment)">
            <div class="equipment">
              <div class="name">{{ equipment.name }}</div>
              <div class="equipment-meta-info">{{ equipment.tenant.name }}</div>
            </div>
          </nb-list-item>
        }
      </nb-list>
    </div>
  </ng-template>
}
